/**
 * Session Storage utilities for logout cleanup to prevent data persistence across user sessions
 */

/**
 * Global logout handler that clears both session and local storage
 */
export const onLogout = (): void => {
    sessionStorage.clear();
    localStorage.clear();
};
